import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { clientSideGeolocate } from 'lib/location/Geolocate';
import css from 'styled-jsx/css';
import ReactLoading from 'react-loading';
import { colors, fonts } from 'components/styles/variables';
import Geocode from 'types/Geocode';
import geolocateIcon from '../public/static/images/paid_landing/location.svg';

interface CurrentLocationProps {
  trackingCategory?: string;
  onLocated: (location: Geocode) => void;
  onCurrentLocationTap?: () => Promise<void>;
}

export function CurrentLocation({
  onLocated,
  onCurrentLocationTap = (): Promise<void> => Promise.resolve(),
}: CurrentLocationProps): JSX.Element {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  async function getCurrentLocation(): Promise<void> {
    setIsLoading(true);

    try {
      const location = await clientSideGeolocate();

      setIsLoading(false);
      onLocated(location);
    } catch (e) {
      setIsLoading(false);
      console.error(e);
    }
  }

  /* istanbul ignore next */
  const scoped = css.resolve`
    .is-loading {
      float: left;
      margin-left: 16px;
      margin-right: 16px;
    }
  `;

  return (
    <li
      onClick={(): void => {
        getCurrentLocation();
        onCurrentLocationTap();
      }}
      className="location"
      data-testid="current-location"
    >
      <ReactLoading
        type="spokes"
        color={colors.BLACK}
        width={20}
        height={20}
        className={`link ${scoped.className} ${isLoading ? 'is-loading' : 'hidden'}`}
      />
      {isLoading ? null : <div className="geolocation" />}
      <div className="current-location">{t('locationAutocomplete.geolocation')}</div>
      {scoped.styles}
      <style jsx>
        {`
          .location:hover {
            background-color: ${colors.G1};
          }

          .geolocation {
            float: left;
            margin-left: 0px;
            margin-top: -5px;
            margin-right: 14px;
            z-index: 1;
            height: 35.5px;
            width: 35.5px;
            background-image: url(${geolocateIcon});
            background-size: contain;
            background-repeat: no-repeat;
            cursor: pointer;
          }

          .current-location {
            font-family: ${fonts.default};
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            padding-top: 3px;
          }
        `}
      </style>
    </li>
  );
}
